<template>
  <div>
    <DelimiterLine v-if="delimiter"/>
    <div class="flex justify-between">
      <div class="buttons">
        <slot name="left"/>
      </div>
      <div class="buttons ml-auto">
        <slot/>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import DelimiterLine from '@/components/DelimiterLine.vue';

const { delimiter = true } = defineProps<{
  delimiter?: boolean;
}>();
</script>

<style scoped lang="scss">
  .buttons {
    @apply flex items-center gap-20;
  }
</style>
